(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yp-product-steps"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('yp-product-steps'))customElements.define('yp-product-steps',class extends HTMLElement{
  connectedCallback(){
    this.abort?.abort();this.abort=new AbortController();this.options={signal:this.abort.signal};
    this.root=this.closest('.product__section-content');if(!this.root)return;
    this.observer=new MutationObserver(()=>{if(!this.ready)this.setup();});
    this.observer.observe(this.root,{childList:true,subtree:true});this.setup();
  }
  setup(){
    if(this.ready)return;
    const children=[...this.root.children];
    const block=selector=>children.find(el=>el.matches(selector)||el.querySelector(selector));
    this.frame=block('.product__section-content__block--variant-picker');
    this.photo=block('.cl-upload--wrapper');this.textBlock=block('.line-item-property__field textarea');
    this.buy=block('.product__section-content__block--buttons');
    if(!this.frame||!this.photo||!this.textBlock||!this.buy)return;
    this.textarea=this.textBlock.querySelector('textarea');
    const photoNote=this.photo.nextElementSibling;const textNote=this.textBlock.nextElementSibling;
    this.groups=[[this.frame],[this.photo],[this.textBlock]];
    if(photoNote?.classList.contains('product__section-content__block--text_with_icon'))this.groups[1].push(photoNote);
    if(textNote?.classList.contains('product__section-content__block--text_with_icon'))this.groups[2].push(textNote);
    const suggestions=block('.yp-suggested-messages');if(suggestions)this.groups[2].push(suggestions);
    this.finalOnly=[this.buy,block('.product__section--payment-icons')].filter(Boolean);
    this.actions=this.querySelector('template').content.firstElementChild.cloneNode(true);
    const anchor=block('.yp-order-assurance')||this.buy;anchor.before(this.actions);
    this.error=this.actions.querySelector('[role="alert"]');
    this.actions.querySelector('.yp-steps__back').addEventListener('click',()=>this.show(this.step-1,true),this.options);
    this.actions.querySelector('.yp-steps__next').addEventListener('click',()=>this.go(this.step+1),this.options);
    this.querySelectorAll('[data-step]').forEach(button=>button.addEventListener('click',()=>this.go(Number(button.dataset.step)),this.options));
    const guard=event=>{
      if(!this.photoReady()){event.preventDefault();event.stopImmediatePropagation();this.show(1,true);this.fail(this.dataset.photoError);return;}
      if(!this.textarea.value.trim()){event.preventDefault();event.stopImmediatePropagation();this.show(2,true);this.fail(this.dataset.textError);this.textarea.focus();}
    };
    this.buy.addEventListener('click',event=>{if(event.target.closest('button[type="submit"]'))guard(event);},{...this.options,capture:true});
    this.buy.addEventListener('submit',guard,{...this.options,capture:true});
    this.root.addEventListener('invalid',event=>{if(this.textBlock.contains(event.target)){this.show(2,false);}},{...this.options,capture:true});
    this.root.addEventListener('shopify:block:select',event=>{const i=this.groups.findIndex(group=>group.some(el=>el.contains(event.target)||event.target.contains(el)));if(i>=0)this.show(i,false);},this.options);
    this.frame.addEventListener('keydown',event=>{const label=event.target.closest('label.yp-frame-choice');if(label&&(event.key==='Enter'||event.key===' ')){event.preventDefault();label.click();}},this.options);
    this.ready=true;this.observer.disconnect();this.hidden=false;this.root.classList.add('yp-wizard-active');this.show(0,false);
  }
  photoReady(){
    const items=[...this.photo.querySelectorAll('.filepond--item')];
    const saved=this.root.querySelector('input[type="hidden"][name="properties[_Pet photo]"]');
    return !!saved?.value.trim()&&items.length===1&&items.every(item=>{
      const states=(item.dataset.filepondItemState||'').split(/\s+/);
      return !states.some(state=>state==='busy'||state.includes('error')||state==='processing')&&(states.includes('idle')||states.includes('processing-complete'));
    });
  }
  fail(message){this.error.textContent=message;this.error.hidden=false;}
  go(step){
    if(step===2&&!this.photoReady()){this.show(1,true);this.fail(this.dataset.photoError);return;}
    this.show(step,true);
  }
  show(step,focus){
    this.step=Math.max(0,Math.min(2,step));this.error.hidden=true;
    this.groups.forEach((group,i)=>group.forEach(el=>el.toggleAttribute('data-yp-step-hidden',i!==this.step)));
    this.finalOnly.forEach(el=>el.toggleAttribute('data-yp-step-hidden',this.step!==2));
    this.querySelectorAll('[data-step]').forEach(button=>{const i=Number(button.dataset.step);if(i===this.step)button.setAttribute('aria-current','step');else button.removeAttribute('aria-current');button.toggleAttribute('data-complete',i<this.step);});
    this.querySelectorAll('[data-status]').forEach(el=>el.hidden=Number(el.dataset.status)!==this.step);
    this.actions.querySelector('.yp-steps__back').hidden=this.step===0;
    this.actions.querySelector('.yp-steps__next').hidden=this.step===2;
    this.actions.querySelectorAll('[data-next-label]').forEach(el=>el.hidden=Number(el.dataset.nextLabel)!==this.step);
    if(focus)this.querySelector('.yp-steps__status').focus({preventScroll:true});
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.actions?.remove();this.root?.classList.remove('yp-wizard-active');this.root?.querySelectorAll('[data-yp-step-hidden]').forEach(el=>el.removeAttribute('data-yp-step-hidden'));this.ready=false;}
});
  } catch(e) { console.error(e); }
})();

})();
